var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"commissionRateCell fz-13"},[_c('div',[_c('span',{staticClass:"mr-6"},[_vm._v("普通")]),_c('span',[_vm._v(_vm._s(_vm.row.commission_rate)+"%")])]),_c('div',[_c('span',{staticClass:"mr-6"},[_vm._v("团长")]),_c('span',[_vm._v(_vm._s(_vm.row.activity_commission_rate)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }